import { Injectable, inject } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Injectable({
  providedIn: 'root',
})
export class LangService {
  private KEY_LANG = 'solventa-lang'

  translate: TranslateService = inject(TranslateService)

  constructor() {
    void 0
  }

  initLang(): void {
    localStorage.getItem(this.KEY_LANG)

    // if (lang) {
    //     this.translate.use(lang)
    // } else {
    //     this.changeLang(this.translate.getBrowserLang()!)
    // }

    this.changeLang('es')
  }

  changeLang(lang: string) {
    localStorage.setItem(this.KEY_LANG, lang)
    this.translate.use(lang)
  }
}
